(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('click',function(event){const openButton=event.target.closest('[data-product-quote-open]');if(openButton)openButton.parentElement.querySelector('[data-product-quote-dialog]').showModal();const closeButton=event.target.closest('[data-product-quote-close]');if(closeButton)closeButton.closest('[data-product-quote-dialog]').close();if(event.target.matches('[data-product-quote-dialog]'))event.target.close();});

function revealProductQuoteResponse(){const form=document.getElementById('UVDTFProductQuote');const dialog=document.querySelector('[data-product-quote-dialog]');if(form&&dialog&&form.querySelector('[role="status"],.errors')&&!dialog.open)dialog.showModal()}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',revealProductQuoteResponse);else revealProductQuoteResponse();document.addEventListener('shopify:section:load',revealProductQuoteResponse);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-overlay-button"] && !Shopify.designMode) return;
  try {
    
(function(){
  const mounts=new Map();
  function reset(){
    for(const [source,entry] of mounts){
      if(source.isConnected)source.appendChild(entry.layer);else entry.layer.remove();
      entry.layer.hidden=true;
      entry.target.classList.remove('uv-overlay-anchor');
    }
    mounts.clear();
  }
  function mount(){
    reset();
    document.querySelectorAll('[data-uv-overlay-source]').forEach(function(source){
      const wrapper=source.closest('.shopify-section');
      const layer=source.querySelector('.uv-overlay-layer');
      const notice=source.querySelector('[data-overlay-notice]');
      let target=null;
      if(source.dataset.anchor==='image'){
        target=document.querySelectorAll('.product__image')[Number(source.dataset.image)-1];
      }else if(wrapper){
        target=wrapper.previousElementSibling;
        while(target&&target.querySelector('[data-uv-overlay-source]'))target=target.previousElementSibling;
      }
      if(!layer)return;
      if(target&&target!==wrapper&&!target.contains(source)){
        target.classList.add('uv-overlay-anchor');
        target.appendChild(layer);
        layer.hidden=false;
        mounts.set(source,{layer:layer,target:target});
        if(notice)notice.hidden=true;
      }else if(notice){notice.hidden=false;}
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount);else mount();
  document.addEventListener('shopify:section:load',mount);
  document.addEventListener('shopify:section:reorder',mount);
  document.addEventListener('shopify:section:unload',function(event){
    for(const [source,entry] of mounts){
      if(event.target.contains(source)||event.target.contains(entry.target)){
        entry.layer.hidden=true;
        source.appendChild(entry.layer);
        entry.target.classList.remove('uv-overlay-anchor');
        mounts.delete(source);
      }
    }
    for(const entry of mounts.values())entry.target.classList.add('uv-overlay-anchor');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uvdtf-global-quote"]) return;
  try {
    document.addEventListener('click',function(event){const opener=event.target.closest('a[href="#UVDTFGlobalQuote"]');if(opener){event.preventDefault();document.getElementById('UVDTFGlobalQuote').showModal()}if(event.target.closest('[data-gq-close]'))document.getElementById('UVDTFGlobalQuote').close();if(event.target.id==='UVDTFGlobalQuote')event.target.close()});
function revealGlobalQuoteResponse(){const form=document.getElementById('UVDTFGlobalQuoteForm');const dialog=document.querySelector('#UVDTFGlobalQuote');if(form&&dialog&&form.querySelector('[role="status"],.errors')&&!dialog.open)dialog.showModal()}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',revealGlobalQuoteResponse);else revealGlobalQuoteResponse();document.addEventListener('shopify:section:load',revealGlobalQuoteResponse);

  } catch(e) { console.error(e); }
})();
})();
